const MediaTypeEnum = {
  videoMedia: 1,
  imageMedia: 2,
  media3D: 3,
  pdfMedia: 4,
  audioMedia: 5
}

export default MediaTypeEnum;
